import { useCallback, useEffect, useMemo } from "react";
import { AdminService } from "../../../../../services";
import { getColumns, getExpandTableColumns } from "../../config";
import { useApplications } from "../../../../../context/Applications";

export const useRequests = ({
  userRoles = [],
  requestsFetched,
  fetchRequests = () => { },
  search = '',
  activeFilters = {},
  perPage = 20,
  setPage = () => { },
  setLoading = () => { },
  setExpandedRows = () => { },
  setToggledKeys = () => { },
  loadingKeys = [],
  page = 1,
  fetchUsers = () => { },
  options = {},
  columnConfig = {},
  t = (s) => s,
}) => {
  const { applications } = useApplications();

  useEffect(() => {
    if (requestsFetched) {
      fetchRequests({ search, activeFilters, page: 1, perPage });
      setPage(1);
    }
  }, [search, activeFilters]);

  const onApproveRequest = useCallback(async (u) => {
    setLoading(true);

    try {
      await AdminService.toggleRequest(u.users[0].id, {
        company: u,
        id: u.id,
        approvalStatus: 'approved',
      })
      setExpandedRows([]);
      setToggledKeys([]);
      loadingKeys.current = {};
      fetchRequests({ page, perPage });
      fetchUsers({});
    } catch (err) {
      console.log(err);
    }

    setLoading(false);
  }, [fetchRequests, setLoading, fetchUsers, page, perPage]);

  const onDeclineRequest = useCallback(async (u) => {
    setLoading(true);

    try {
      await AdminService.toggleRequest(u?.admin?.id, {
        company: u,
        id: u.id,
        approvalStatus: 'declined',
      })
      setExpandedRows([]);
      setToggledKeys([]);
      loadingKeys.current = {};
      fetchRequests({ page, perPage });
      fetchUsers({});
    } catch (err) {
      console.log(err);
    }

    setLoading(false);
  }, [fetchRequests, fetchUsers, setLoading, page, perPage]);

  const onResendVerification = useCallback(async (id) => {
    setLoading(true);

    try {
      await AdminService.resendVerification(id);
    } catch (err) {
      console.log(err);
    }

    setLoading(false);
  }, [setLoading]);

  const headerColumns = useMemo(() =>
    getColumns({ t, ...columnConfig, options, view: 'requests', onDeclineRequest, onApproveRequest, onResendVerification, applications })
      .filter((v) => v.show), [t, columnConfig, onDeclineRequest, onApproveRequest, onResendVerification, options, applications]);

  const expandedTableColumns = useMemo(() =>
    getExpandTableColumns({ t, ...columnConfig, view: 'requests', userRoles, applications })
      .filter((v) => v.show), [t, columnConfig, userRoles, applications]);

  return {
    headerColumns,
    expandedTableColumns,
  };
};
